import styled from 'styled-components';
import { Tabs, TabsPanelProps } from '@mantine/core';

// Each tab owns its own scroll: bounded by the flex chain (min-height: 0) and
// scrolls its own overflow.
export const TabPanel = styled(Tabs.Panel)<TabsPanelProps>`
	flex: 1;
	min-height: 0;
	overflow: auto;
	position: relative;
	padding: 0.5rem;
`;
